

















































import Vue from 'vue';

export default Vue.extend({
    props: {
        toastDataPreview: {
            type: Object,
            default: () => ({} as any),
        },
        render: {
            type: String,
        },
        type: {
            type: Object,
        },

    },
    data() {
        return {
            panel: 0,

            backgroundColor: '',
            textColor: '',
            tostForm: {
                title: null,
                subtitle: null,
                content: null,
            },
        };
    },
    watch: {
        render() {
            this.updateFields();
            this.setBackgroundColor(this.toastDataPreview.style);
        },
    },
    methods: {
        updateFields() {
            this.tostForm.title = this.toastDataPreview.title;
            this.tostForm.subtitle = this.toastDataPreview.subtitle;
            this.tostForm.content = this.toastDataPreview.content;

        },
        setBackgroundColor(color: string) {
            switch (color) {
            case 'blue':
                this.backgroundColor = 'rgb(8, 21, 65)';
                this.textColor = 'white';
                break;
            case 'green':
                this.backgroundColor = 'rgba(0, 181, 129, 1)';
                this.textColor = 'white';
                break;
            case 'gray':
                this.backgroundColor = 'rgb(246, 248, 255)';
                this.textColor = '#08154D';
                break;
            default:
                this.backgroundColor = 'rgb(246, 248, 255)';
                this.textColor = '#08154D';
                break;
            }
        },

    },
    created() {
        this.updateFields();
        this.setBackgroundColor(this.toastDataPreview.style);
    },
});
